/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowDownIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m18.907 33.563-10.493-11c-.562-.625-.562-1.563.063-2.125.624-.563 1.561-.563 2.123.062l7.932 8.313V7.5c0-.812.625-1.5 1.5-1.5a1.52 1.52 0 0 1 1.498 1.5v21.313L29.4 20.5c.562-.625 1.561-.625 2.124-.062.624.562.624 1.5.062 2.125l-10.493 11a1.46 1.46 0 0 1-1.062.437c-.437 0-.812-.125-1.124-.437"/>}
        </IconWrapper>);
}
